import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import './Home.css';
import CompanySearch from '../components/CompanySearch';
import AdvantagesSlider from '../components/AdvantagesSlider';
import DeepBuffettLink from '../components/DeepBuffettLink';
import activityTracker from '../user/ActivityTracker';

const Home = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    activityTracker.trackPageView('home');
  }, []);
  
  const techGiants = [
    { symbol: 'AAPL', name: '蘋果' },
    { symbol: 'MSFT', name: '微軟' },
    { symbol: 'GOOGL', name: '谷歌' },
    { symbol: 'AMZN', name: '亞馬遜' },
    { symbol: 'META', name: 'Meta' },
    { symbol: 'TSLA', name: '特斯拉' },
    { symbol: 'NVDA', name: '輝達' }
  ];

  const handleTechGiantClick = (symbol) => {
    navigate(`/business-product?symbol=${symbol}&autoload=true`);
  };

  const advantages = [

    {
      title: '全亞洲唯一法說逐字稿 AI分析整理',
      content: '提供原文翻譯比對、快速拉取逐字稿、AI 重點分析整理。法說會會議紀錄近萬字，只要十秒鐘快速提取你感興趣的未來展望關鍵資訊。'
    },
    {
      title: '市場唯一免費提供20年財務數據',
      content: '提供20年以上的財務數據，視覺化圖表讓趨勢一目瞭然 (開發中)。全球唯一提供20年以上免費的年度數據。'
    },
    {
      title: '全網最詳盡的公司業務產品分析介紹',
      content: '提供最新最完整最準確的公司產品線介紹及現況，分析公司商業模式、護城河及未來發展狀況，讓你快速掌握公司現況。任何的新公司只需要10秒鐘，你就可快速掌握公司輪廓。'
    },
    {
      title: '全方位個股AI分析健檢',
      content: '你還在到處尋找機構的分析文件嗎？到處看youtuber們的分析嗎？DeepBuffett 以法說會、財報文件、財務數字、過去數據為基礎，提供華爾街等級的全方位個股分析，讓你擁有像巴菲特一般的幫手，協助你分析財報，節省你大量的時間。'
    },
    {
      title: 'AI 人性化對話式 選股功能 (開發中)',
      content: '你還在艱澀難懂的選股指標煩惱嗎? 還在自己一個一個選指標嗎？直接告訴我你想要的股票類型，我提供你對應的篩選的條件再幫你篩選股票。'
    }
  ];

  return (
    <div className="home-container">
      <Helmet>
        <title>科技巴菲特 DeepBuffett</title>
        <meta name="description" content="DeepBuffett 提供 AI 財報分析、逐字稿分析、免費財報資料庫、中文翻譯與商模分析，幫助您快速掌握企業價值。" />
        <meta name="keywords" content="逐字稿,法說會,AI,GPT,未來展望,美股分析,翻譯,財報分析,巴菲特,價值投資" />
        <meta property="og:title" content="DeepBuffett - AI 財報分析工具 | 巴菲特式價值投資分析" />
        <meta property="og:description" content="DeepBuffett 提供 AI 財報分析、逐字稿分析、免費財報資料庫、中文翻譯與商模分析，幫助您快速掌握企業價值。" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.deepbuffett.com" />
        <meta property="og:image" content="https://www.deepbuffett.com/logo.png" />
        <link rel="icon" type="image/png" href="/images/deepbuffett_logo2.png" />
      </Helmet>

      <section className="hero-section">
        <h1>模仿巴菲特要10年功 現在只要10秒鐘</h1>
        <h2>DeepBuffett 科技巴菲特<br></br>提供 最新財報資料翻譯 以及 關鍵摘要AI生成</h2>
     
        <div className="search-container">
          <CompanySearch onSelect={(company) => navigate(`/business-product?symbol=${company.symbol}&autoload=true`)} />
          <div className="tech-giants-container">
            <h4>美股七巨頭</h4>
            <div className="tech-giants-grid">
              {techGiants.map((company) => (
                <button
                  key={company.symbol}
                  className="tech-giant-button"
                  onClick={() => handleTechGiantClick(company.symbol)}
                >
                  <span className="symbol">{company.symbol}</span>
                  <span className="name">{company.name}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="value-proposition">
        <p className="time-savings">
          只要10秒鐘 — 將省下你數小時的收集尋找翻譯消化整理以及觀看財經博主的時間。
        </p>
        
        <div className="investment-types">
          <h3>不管你是要：</h3>
          <ul>
            <li>長期投資</li>
            <li>波段投資</li>
            <li>抄底股票</li>
            <li>價差投資</li>
          </ul>
          <p>
            你都需要一位像巴菲特一樣的助手來協助你進行大量的基本面分析，
            這將基於你的投資策略提供更堅實的投資基礎
          </p>
        </div>
      </section>

      <section className="ai-features">
        <h2>科技巴菲特 <span className="highlight">結合 AI 的智能分析平台</span></h2>
        <p className="ai-description">AI分析-最新財報和會議紀錄；提供華爾街等級的趨勢、成長、經營與風險分析。以深度學習為核心，提供快速、深度、準度的個股解析。</p>
        <div className="video-grid">
          <div className="video-item">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/oGAwwNhiMRo?si=g7yFk2uGaRA4tr9A" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
          <div className="video-item">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/oGAwwNhiMRo?si=IY6zq61-EZiSZJ8r" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
        </div>
  
      </section>

      <section className="advantages-section">
        <h2>五大核心優勢</h2>
        <AdvantagesSlider advantages={advantages} />
      </section>

      <DeepBuffettLink />

      <section className="cta-section">
        <h2>你想擁有一位像巴菲特一般的助手 ?</h2>
        <Link to="/register" className="cta-button">
          馬上來試用吧！
        </Link>
      </section>
    </div>
  );
};

export default Home; 